import Modal from '/global/components/modal'
import { setFocus } from '/helpers/misc'

/** >>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>
 * Component: `.testimonials`
 * This toggles the card states of testimonials
*** >>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>*/

export default function() {

	const $html = document.querySelector('html')

	_.each(document.querySelectorAll('.testimonials .card'), $card => {
		const $outer = $card.querySelector('.outer')
		const $brief = $card.querySelector('.brief')
		const $detail = $card.querySelector('.testimonial-detail')
		function clickCard(event) {
			if (event.type === 'click' || event.keyCode === 13 || event.keyCode === 32) {
				event.preventDefault()
				$html.classList.remove('header-up')
				$brief.setAttribute('aria-hidden', 'true')
				$outer.setAttribute('aria-expanded', 'true')
				$detail.removeAttribute('aria-hidden')

				Modal.$body.appendChild($detail)

				Modal.open({
					onClose: () => {
						$brief.removeAttribute('aria-hidden')
						$outer.setAttribute('aria-expanded', 'false')
						$detail.setAttribute('aria-hidden', 'true')
						$brief.parentElement.appendChild($detail)
						setFocus($card.parentElement)
					},
				})
				objectFitImages(Modal.$body.querySelector('img'))
			}
		}

		$outer.addEventListener('click', clickCard)
		$outer.addEventListener('keydown', clickCard)
	})

}
